"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = exports.TableHeaderCell = exports.TableContainer = exports.TableCell = void 0;
var _react = require("react");
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Style = require("../style/Style");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TableContainer = exports.TableContainer = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableContainer, {
    ...props,
    ref: ref,
    ...stylex.props(_Style.tableStyle.container),
    children: props.children
  });
});
const TableRow = exports.TableRow = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableRow, {
    ...props,
    ref: ref,
    ...stylex.props(_Style.tableStyle.row),
    children: props.children
  });
});
const TableCell = exports.TableCell = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
    ...props,
    ref: ref,
    ...stylex.props(_Style.tableStyle.cell, _Style.tableStyle.bodyCell, _Style.textStyle.p1, props.isCenter && _Style.tableStyle.centerCell, props.isSmall && _Style.tableStyle.smallCell),
    children: props.children
  });
});
const TableHeaderCell = exports.TableHeaderCell = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
    ...props,
    ref: ref,
    ...stylex.props(_Style.tableStyle.cell, _Style.textStyle.p1b),
    children: props.children
  });
});